import {css} from '@emotion/react'
import {Select as AntdSelect} from 'antd'
import InputText from './InputText.jsx'
import {useReadOnly} from './ReadOnly.mjs'
import stopPropagation from './stopPropagation.mjs'
import useSelectable from './useSelectable2.mjs'

const cssSelect = css({
    display: 'block',
    width: '100%',
    color: 'inherit',
    overflow: 'hidden',
})

export default function Select({
    autoSelect,
    getOptionKey,
    getOptionLabel,
    getOptionLabelText,
    getOptionSearchText,
    getOptionStyle,
    getOptionTitle,
    getOptionWriteBack,
    hottestFirst,
    keyAsValue,
    mode,
    options,
    readOnly,
    value,
    onChange,
    ...props
}) {
    const gReadOnly = useReadOnly()

    const {
        antdOptions,
        filterOption,
        filterSort,
        handleChange,
        inputValue,
    } = useSelectable({
        autoSelect,
        getOptionKey,
        getOptionLabel,
        getOptionLabelText,
        getOptionSearchText,
        getOptionStyle,
        getOptionTitle,
        getOptionWriteBack,
        hottestFirst,
        keyAsValue,
        mode,
        options,
        onChange,
        value,
    })

    if (readOnly || gReadOnly) {
        const selectedOption = antdOptions.find(e => e.value === inputValue)
        const label = selectedOption?.label ?? ''

        return (
            <InputText
                readOnly
                value={label}
            />
        )
    }
    else {
        return (
            <AntdSelect
                css={cssSelect}
                filterOption={filterOption}
                filterSort={filterSort}
                mode={mode}
                optionLabelProp="writeBack"
                showSearch
                value={inputValue}
                onChange={handleChange}
                onClick={stopPropagation}
                options={antdOptions}
                {...props}
            />
        )
    }
}
